module.exports = __webpack_public_path__ + "img/62.da9ab684.png";